import { Group, GroupType } from './types';

export const isGroupValid = (group: Group) => {
    return group.name && group.group_type
        && (group.group_type !== GroupType.PeerGroup || group.weighting);
};

export const isBenchmarkGroup = (group: Group) => {
    return group.group_type === GroupType.BenchmarkGroup;
};